import { render, staticRenderFns } from "./imposition.vue?vue&type=template&id=49fadec0"
import script from "./imposition.vue?vue&type=script&lang=js"
export * from "./imposition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports